import { Response } from '../../quill-marking-logic/src/main';

export interface Attempt {
  response: Response
}

export function getAnswerState(attempt: Attempt|undefined): boolean {
  if (attempt) {
    return !!(attempt.response.optimal)
  }
  return false
}
